import { useState } from "react";
import { FaPlus } from "react-icons/fa6";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import Pagination from "../../../../shared/components/Pagination";
import useFetchClassDetails from "../../../../shared/api/classes/useFetchClassDetails";
// import ClassNavigationBar from "../../../../shared/components/classes/ClassNavigationBar";
import StudentDetails from "../../../../shared/components/classes/classDetails/StudentDetails";
import useFetchClassStudents from "../../../../shared/api/classes/students/useFetchClassStudents";
import ModifyClassTeacher from "../../../../shared/components/classes/classDetails/ModifyClassTeacher";
import ClassStudentsTable from "../../../../shared/components/classes/classDetails/ClassStudentsTable";
import ClassDetailsOverview from "../../../../shared/components/classes/classDetails/ClassDetailsOverview";

const ClassDetails = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const studentId = query.get("student");
  const type = query.get("type");
  const action = query.get("action");

  const { classId, schoolId } = useParams();
  const navigate = useNavigate();

  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(null);

  const [classLoading, classDetails, fetchClassDetails] =
    useFetchClassDetails(classId);
  const [loadingStudents, students] = useFetchClassStudents(
    classId,
    page,
    setPagination
  );

  function closeSideModal() {
    navigate(`/${schoolId}/classes/${classId}`);
  }

  return (
    <div>
      <div className="page">
        <div className="mb-5 flex items-center justify-between">
          <div className="page_title_container">
            <h1 className="page_title">Students</h1>

            <p className="page_subtitle">
              {classDetails
                ? `(${classDetails?.category} ${classDetails?.suffix})`
                : null}
            </p>
          </div>

          <button
            className="flex items-center justify-center gap-1 bg-primary h-8 xxs:h-8 ssm:h-9 rounded-sm text-white px-3 min-w-[80px]"
            onClick={() =>
              navigate(`/${schoolId}/classes/${classId}/add-student`)
            }
          >
            <FaPlus className="text-sm" />
            <small>Add Student</small>
          </button>
        </div>

        {/* <ClassNavigationBar activeIndex={0} /> */}

        <div className="main_content">
          <ClassDetailsOverview
            classDetails={classDetails}
            loading={classLoading}
          />

          <ClassStudentsTable
            data={students}
            loading={loadingStudents}
            studentId={studentId}
          />

          <Pagination setPage={setPage} pagination={pagination} />
        </div>
      </div>

      {studentId && type === "details" ? (
        <div className="page_dark_overlay" onClick={closeSideModal} />
      ) : null}

      <div className={`page_right_bar ${studentId || action ? "block" : ""}`}>
        <StudentDetails
          studentId={studentId}
          type={type}
          closeSideModal={closeSideModal}
        />

        <ModifyClassTeacher
          classDetails={classDetails}
          action={action}
          refresh={fetchClassDetails}
        />
      </div>
    </div>
  );
};

export default ClassDetails;
